import { render } from "./Signup.vue?vue&type=template&id=5d10b54d&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=5d10b54d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d10b54d"]])

export default __exports__